export const ADMIN_HOME_PATH = '/painel-admin'
export const DEFAULT_HOME_PATH = '/dashboard'

export const getHomePath = (roleSlug?: string | null) =>
  roleSlug === 'ADMIN' ? ADMIN_HOME_PATH : DEFAULT_HOME_PATH

export const isDashboardHomePath = (pathname: string) =>
  pathname === DEFAULT_HOME_PATH || pathname === ADMIN_HOME_PATH
